import {
    GET_ALL_DOMAIN_BEGIN,
    GET_ALL_DOMAIN_SUCCESS,
    GET_ALL_DOMAIN_ERROR,
    ADD_DOMAIN_BEGIN,
    ADD_DOMAIN_SUCCESS,
    ADD_DOMAIN_ERROR,
    GET_DOMAIN_BEGIN,
    GET_DOMAIN_ERROR,
    GET_DOMAIN_SUCCESS,
    UPDATE_DOMAIN_BEGIN,
    UPDATE_DOMAIN_SUCCESS,
    UPDATE_DOMAIN_ERROR,
    DELETE_DOMAIN_BEGIN,
    DELETE_DOMAIN_SUCCESS,
    DELETE_DOMAIN_ERROR,
  } from "./constants";
  
  const initState = {
    list: [],
    loading: false,
    error: null,
  };
  
  const DomainReducer = (state = initState, action) => {
    const { type, data, error } = action;
    switch (type) {
      case GET_ALL_DOMAIN_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case GET_ALL_DOMAIN_SUCCESS:
        return {
          ...state,
          list: data,
          loading: false,
        };
      case GET_ALL_DOMAIN_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case ADD_DOMAIN_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case ADD_DOMAIN_SUCCESS:
        return {
          ...state,
          loading: false,
          list: [...state.list, data],
        };
      case ADD_DOMAIN_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case GET_DOMAIN_BEGIN:
        return {
          ...state,
          loading: true,
          domainData: "",
        };
      case GET_DOMAIN_SUCCESS:
        return {
          ...state,
          loading: false,
          domainData: data,
        };
      case GET_DOMAIN_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case UPDATE_DOMAIN_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case UPDATE_DOMAIN_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.map((ele) => {
            if (ele.id === data.id) {
              return { ...data };
            } else return ele;
          }),
        };
      case UPDATE_DOMAIN_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      case DELETE_DOMAIN_BEGIN:
        return {
          ...state,
          loading: true,
        };
      case DELETE_DOMAIN_SUCCESS:
        return {
          ...state,
          loading: false,
          list: state.list.filter((ele) => ele.id !== data.id),
        };
      case DELETE_DOMAIN_ERROR:
        return {
          ...state,
          error,
          loading: false,
        };
      default:
        return state;
    }
  };
  
  export default DomainReducer;
  